
export function notEmpty<T>(val: T): T | never {
    if (val === undefined || val === null || val === '') throw new Error(`Value is empty: ${val}`);
    else if (Array.isArray(val) && val.length === 0) throw new Error(`Array is empty: ${val}`);
    else if (typeof val === 'object' && Object.keys(val).length === 0) throw new Error(`Object is empty: ${val}`);
    return val as T;
}